import React from 'react'
import Logo from "../assets/logo1.png"

function Title() {
    return (
        <div>
            <div className="container-fluid" style={{backgroundColor: "#e2566d"}}>
      <div className="justify-content-center text-center py-5">
        <img src={Logo} alt="logo" className=""/>
        <div className="fs-5 text-center pt-5" style={{color: "#ecc9c8"}}>
          <pre className="shadow">
J O U R N E Y  T H R O U G H  M Y  J O U R N A L</pre
          >
        </div>
        {/* <!-- <h2 className="mt-3" style="color: #d3d8da">JOURNEY THROUGH MY JOURNAL</h2> --> */}
      </div>
    </div>
        </div>
    )
}

export default Title;